import React from "react"

export default function FieldSelectFields_FormValueNotEmpty(props:any) {

    const onDelete = (fieldId:ID) => {
        props.onChange(gd.utils.toggleArrayValue(props.value, fieldId), false)
    }

    const valueClasses = Classes("ui5-field-form-editable dropdown-form fl-wrap min-h-36", props.className)

    const selectedFields = _.map(props.value, fieldId=>props.field.fields.get(fieldId))

    return (
        <React.Fragment>
            <div className={valueClasses} onClick={props.onClick}>
                {_.map(selectedFields, field =>
                    <props.field.components.Pill key        = {field.fieldId}
                                                 className  = "m-r-10 m-t-4 m-b-4"
                                                 field      = {field}
                                                 onDelete   = {onDelete}/>
                )}
            </div>
            {props.children}
        </React.Fragment>
    );
}
